import { Routes, Route, Navigate } from 'react-router-dom';

import AuthLayout from '../layouts/AuthLayout';
import AppLayout from '../layouts/AppLayout';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import PermissionRoute from './PermissionRoute';

import Login from '../views/auth/Login';
import ForgetPassword from '../views/auth/ForgetPassword';
import ForgetPasswordSubmit from '../views/auth/ForgetPasswordSubmit';
import ChangePassword from '../views/auth/ChangePassword';
import Role from '../views/Role';
import Home from '../views/Home';
import Doctors from '../views/Doctors';
import Admins from '../views/Admins';
import Caregivers from '../views/Caregivers';
import Call from '../views/Call';
import CreateDoctor from '../views/CreateDoctor';
import CreateCaregiver from '../views/CreateCaregiver';
import MyProfile from '../views/MyProfile';
import EditUser from '../views/EditUser';
import CaregiverDashboard from '../views/CaregiverDashboard';
import Documents from '../views/Documents';
import Appointments from '../views/Appointments';
import Settings from '../views/Settings';
import Restricted from '../views/Restricted';
import { ROUTE_PERMISSION } from '../permissions';

const AppRoutes = () => {
    return (
        <Routes>
            {/* Auth */}
            <Route element={<PublicRoute />}>
                <Route element={<AuthLayout />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgetPassword" element={<ForgetPassword />} />
                    <Route
                        path="/forgetPassword/changePassword"
                        element={<ForgetPasswordSubmit />}
                    />
                    <Route path="/changePassword" element={<ChangePassword />} />
                </Route>
            </Route>

            {/* Protected */}
            <Route element={<ProtectedRoute />}>
                <Route element={<AuthLayout />}>
                    <Route path="/role" element={<Role />} />
                    <Route path="/restricted" element={<Restricted />} />
                </Route>
                <Route element={<AppLayout />}>
                    <Route
                        element={<PermissionRoute routePermission={ROUTE_PERMISSION.HOME} />}
                    >
                        <Route path="/" element={<Home />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.DOCTORS_LIST}
                            />
                        }
                    >
                        <Route path="/doctors" element={<Doctors />} />
                        <Route path="/admins" element={<Admins />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.CAREGIVERS_LIST}
                            />
                        }
                    >
                        <Route path="/caregivers" element={<Caregivers />} />
                        <Route path="/caregivers/:roleUuid" element={<CaregiverDashboard />} />
                    </Route>
                    <Route
                        element={<PermissionRoute routePermission={ROUTE_PERMISSION.HOME} />}
                    >
                        <Route path="/call/:id" element={<Call />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.APPOINTMENTS}
                            />
                        }
                    >
                        <Route path="/appointments" element={<Appointments />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.DOCUMENTS}
                            />
                        }
                    >
                        <Route path="/documents" element={<Documents />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.SETTINGS}
                            />
                        }
                    >
                        <Route path="/settings" element={<Settings />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.MY_PROFILE}
                            />
                        }
                    >
                        <Route path="/myprofile" element={<MyProfile />} />
                        <Route path="/users/:roleUuid/edit" element={<EditUser />} />
                    </Route>

                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.CREATE_DOCTOR}
                            />
                        }
                    >
                        <Route path="/doctors/new" element={<CreateDoctor />} />
                    </Route>
                    <Route
                        element={
                            <PermissionRoute
                                routePermission={ROUTE_PERMISSION.CREATE_CAREGIVER}
                            />
                        }
                    >
                        <Route path="/caregivers/new" element={<CreateCaregiver />} />
                    </Route>
                </Route>
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default AppRoutes;
